import reportTitle from './ReportTitle';

export default [reportTitle];
